import { render, staticRenderFns } from "./CurrencyTotalGroup.vue?vue&type=template&id=61633268&scoped=true&"
import script from "./CurrencyTotalGroup.vue?vue&type=script&lang=js&"
export * from "./CurrencyTotalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61633268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61633268')) {
      api.createRecord('61633268', component.options)
    } else {
      api.reload('61633268', component.options)
    }
    module.hot.accept("./CurrencyTotalGroup.vue?vue&type=template&id=61633268&scoped=true&", function () {
      api.rerender('61633268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/components/CurrencyTotalGroup.vue"
export default component.exports